import React from 'react'
import { MetricSeries, StreamSymbol, MessageConst } from 'enums'
import messageUtil from 'utils/messageUtil'

import PanelColumn from './PanelColumn'
import { resolveMetrics } from './utils'
import { NonNullableDataset } from './types'

interface ForumPanelProps {
  data: NonNullableDataset
  dataStream: string | undefined
}

const ForumPanel = ({ data, dataStream }: ForumPanelProps) => {
  const {
    engagements,
    replies,
    netSentiment,
    positiveSentiment,
    negativeSentiment,
    passion,
    score
  } = resolveMetrics(data)

  return (
    <>
      <PanelColumn
        title={messageUtil.measureType(MetricSeries.TOTAL_ENGAGEMENTS)}
        value={engagements}
      />
      <PanelColumn title={messageUtil.measureType('TWReplies')} value={replies} />
      {netSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.NET_SENTIMENT)}
          value={`${netSentiment}%`}
        />
      )}
      {positiveSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.POSITIVE_SENTIMENT)}
          value={positiveSentiment}
        />
      )}
      {negativeSentiment !== MessageConst.EM_DASH && (
        <PanelColumn
          title={messageUtil.measureType(MetricSeries.NEGATIVE_SENTIMENT)}
          value={negativeSentiment}
        />
      )}
      {passion !== MessageConst.EM_DASH && (
        <PanelColumn title={messageUtil.measureType(MetricSeries.PASSION)} value={passion} />
      )}
      {dataStream === StreamSymbol.BRDRDT2 && score !== MessageConst.EM_DASH && (
        <PanelColumn title={messageUtil.measureType(MetricSeries.SCORE)} value={score} />
      )}
    </>
  )
}
export default ForumPanel
